import React from 'react'
import styled from 'styled-components'
import tw, { theme } from 'twin.macro'
import useBodyScrollLock from '@hooks/useBodyScrollLock'

type Props = {
  containerWidth?: number
  containerHeight?: number
  headerContent?: React.ReactNode
  mainContent?: React.ReactNode
  close: () => void
}

export default function Lightbox(props: Props) {
  const { containerWidth, containerHeight, headerContent, mainContent, close } = props
  const onClick = (e) => {
    if (e.target === e.currentTarget) {
      close()
    }
  }
  useBodyScrollLock()

  return (
    <Background className="lightbox" onClick={onClick}>
      <Container className="container" width={containerWidth} height={containerHeight}>
        <div className="header">{headerContent}</div>
        <div className="main">{mainContent}</div>
      </Container>
    </Background>
  )
}

const Background = styled.div`
  ${tw`items-center flex flex-col z-mask justify-end md:justify-center`}
  ${tw`fixed w-screen h-screen top-0 left-0`}
  background-color: rgba(0, 0, 0, 0.4);
`

const Container = styled.div<{
  width: number
  height: number
}>`
  ${tw`rounded-tl-lg rounded-tr-lg`}
  ${tw`box-border flex flex-col`}
  background-color: rgba(255, 255, 255, 1);

  width: 100%;
  height: calc(100% - 20px);

  @media (min-width: ${theme`screens.md`}) {
    ${(props) => `width: ${props.width}px`};
    ${(props) => `height: ${props.height}px`};
    margin-top: 0px;
    ${tw`rounded-bl-lg rounded-br-lg`}
  }

  .header {
    border-bottom: 1px solid #e6e6e6;
  }

  .main {
    padding: 0 8px;
    flex-grow: 1;
    overflow-y: auto;
    height: 0;
  }
`
